import { gql } from '@apollo/client';

// Fragment-only module, with no component or heavy-library imports, so the global
// fragment registry can register this fragment without pulling the actions cell, and the tables it reaches, into the
// boot-time entry chunk.
export const VISIT_REQUEST_ACTIONS_CELL_FRAGMENT = gql`
    fragment VisitRequestActionsCell on VisitRequest {
        id
        state
        visitRequestWorkflowStep: workflowStep
        permissions {
            id
            edit
        }
        visit {
            id
        }
        warnings {
            message
        }
    }
`;
